import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  pageFooter: {
    display: 'flex',
    marginTop: '40px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  feeSetupWrapper: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  feeSetupCharge: {
    width: '140px',
    flexShrink: '0',
    marginRight: '10px'
  },
  feeSetupGl: {
    width: '100%'
  },
  feeSetupGlItem: {
    display: 'block !important',
    '& i': {
      display: 'block',
      fontSize: '11px',
      fontStyle: 'normal'
    }
  },
  residents: {
    borderRadius: '2px',
    // boxShadow: '0px 4px 24px rgba(85, 100, 119, 0.08)',
    backgroundColor: palette.common.white,
    marginTop: '20px',
    '& .MuiTableContainer-root': {
      boxShadow: 'none'
    }
  },
  residentsSearch: {
    padding: '0 16px 24px 16px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& > div': {
      maxWidth: '400px'
    }
  },
  residentsTableId: {
    color: palette.shades[700],
    display: 'block',
    fontSize: '11px'
  },
  amf: {
    display: 'flex'
  },
  amfValue: {
    '& b': {
      display: 'block',
      fontSize: '13px',
      color: palette.shades[500],
      lineHeight: '16px',
      fontFamily: palette.fontFamilies.poppins
    },
    '& span': {
      display: 'block',
      color: palette.shades[700],
      fontSize: '11px',
      lineHeight: '14px'
    },
    '&.custom': {
      '& b': {
        color: '#212934'
      }
    }
  },
  amfControll: {
    marginTop: '-7px',
    '& .MuiIconButton-root': {
      padding: '4px'
    },
    '& svg': {
      fontSize: '16px',
      '& path': {
        fill: palette.shades[500]
      }
    }
  },
  input: {
    '& .MuiInputBase-input': {
      padding: '6px'
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(12px, 6px) scale(1)'
    },
    '&.disabled': {
      position: 'relative',
      '&:after': {
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '1',
        top: '-10px',
        content: '""',
        display: 'block',
        position: 'absolute',
        backgroundColor: 'rgba(255,255,255, 0.7)'
      }
    }
  },
  glAccount: {
    marginTop: '12px'
  },
  glAccountItem: {
    display: 'block !important',
    '& i': {
      display: 'block',
      fontSize: '11px',
      fontStyle: 'normal'
    }
  }
}));
export default useStyles;